
const initialState={
    products:[],
    isLoading: false,
    isError:false
}

const productsReducer = (state= initialState, action)=>{


    switch(action.type){
          case "FETCH_REQUEST":
          return {
              ...state,
              isLoading:true,
              isError:false
          }
          case "FETCH_SUCESS":
          return {
              ...state,
              products: action.payload,
              isLoading:false,
              isError:false
          }
          case "FETCH_FAILURE":
          return {
              ...state,
              products:[],
              isLoading:false,
              isError: true
          }
          default: 
          return state
      }
  }

  export default  productsReducer